// eslint-disable-next-line no-unused-vars
import {makeAction, makeAsyncAction} from 'common/utils/simplifiedAsync';

const mac = (actionName) => makeAction(actionName, 'anodot/predefinedDatesSetting/');
// eslint-disable-next-line no-unused-vars
const macAsync = (actionName) => makeAsyncAction(actionName, 'anodot/predefinedDatesSetting/');

// eslint-disable-next-line import/prefer-default-export
export const updatePredefinedDatesUserSettings = mac('UPDATE_PREDEFINED_DATES_USER_SETTINGS');
